import {PRICEMODEL_FEATURE_IDS} from "@/js/finPriceModel"

export default {
  items: [
    {
      // id
      id: '0',
      helpCenterId: 'shareScreener',
      // Tool title displayed in card
      name: 'Aktien-Screener',
      // Tool teaser displayed in card
      teaserText: 'Lege die für dich relevanten Kriterien fest und suche nach den passenden Aktien',
      // Tool type displayed in card
      type: 'Aktie',
      // type to allow filtering per share/etf
      filterType: ['share'],
      // route to go to
      to: {name: 'shareScreener'},
      orderNumber: 1,
      priceModelFeatureId: PRICEMODEL_FEATURE_IDS.SHARE_SCREENER.id,
      tracking: {
        event: (route) => `fincraft_${route}_goto_share_screener`,
        step: 'goto_share_screener'
      }
    },
    {
      id: '3',
      helpCenterId: 'etfScreener',
      name: 'ETF-Screener',
      teaserText: 'Lege die für dich relevanten Kriterien fest und suche nach passenden ETFs',
      type: 'ETF',
      filterType: ['etf'],
      to: {name: 'etfScreener'},
      orderNumber: 2,
      priceModelFeatureId: PRICEMODEL_FEATURE_IDS.ETF_SCREENER.id,
      tracking: {
        event: (route) => `fincraft_${route}_goto_etf_screener`,
        step: 'goto_etf_screener'
      }
    },
    {
      id: '1',
      helpCenterId: 'shareRating',
      name: 'Bewerte deine Aktie',
      teaserText: 'Du willst den Wert einer Aktie schätzen, um Über- oder Unterbewertungen zu identifizieren? Hier findest du die passenden Methoden',
      type: 'Aktie',
      filterType: ['share'],
      to: {name: 'finToolsRateShares'},
      orderNumber: 3,
      priceModelFeatureId: PRICEMODEL_FEATURE_IDS.SHARE_RATING.id,
      tracking: {
        event: (route) => `fincraft_${route}_goto_bewerte_deine_aktie`,
        step: 'goto_bewerte_deine_aktie'
      }
    },
    {
      id: '10',
      helpCenterId: 'watchlistsAsTool',
      name: 'Deine Watchlists',
      teaserText: 'Lege Watchlists an um deine Favoriten im Blick zu behalten und beim Erreichen von Schwellenwerten per Alert informiert zu werden',
      type: 'Aktie & ETF',
      filterType: ['share', 'etf'],
      to: {name: 'myWatchlists'},
      orderNumber: 4,
      tracking: {
        event: (route) => `fincraft_${route}_goto_watchlists`,
        step: 'goto_watchlists'
      }
    },
    {
      id: '5',
      helpCenterId: 'performanceAnalyzer1',
      name: 'Performance-Analyzer',
      teaserText: 'Untersuche die Kursentwicklungen von Indizes, Aktien und ETFs über verschiedene Zeiträume',
      type: 'Aktie & ETF',
      filterType: ['share', 'etf'],
      to: {name: 'performanceanalyzer1'},
      orderNumber: 5,
      tracking: {
        event: (route) => `fincraft_${route}_goto_performanceanalyzer`,
        step: 'goto_performanceanalyzer'
      }
    },
    {
      id: '2',
      helpCenterId: 'etfAnalyzer',
      name: 'ETF-Analyzer',
      teaserText: 'Schau dir die Kennzahlen und die Zusammensetzung von ETFs an',
      type: 'ETF',
      filterType: ['etf'],
      to: {name: 'etfAnalyzer'},
      orderNumber: 6,
      finhubHide: true
    },
    {
      id: '4',
      helpCenterId: 'indexAnalyzer',
      name: 'Index-Analyzer',
      teaserText: 'Schau dir die Kennzahlen und die Zusammensetzung von Aktien-Indizes an und suche Top-Down nach deinen Favoriten',
      type: 'Aktie',
      filterType: ['share'],
      to: {name: 'indexAnalyzer'},
      hide: true,
      orderNumber: 7
    },
    {
      id: '6',
      helpCenterId: 'backtesting',
      name: 'Backtesting',
      teaserText: 'Untersuche rückwirkend die Kursentwicklungen von Portfolios',
      type: 'Portfolio',
      priceModelFeatureId: PRICEMODEL_FEATURE_IDS.BACKTESTING.id,
      filterType: ['portfolio'],
      to: {name: 'backtesting'},
      orderNumber: 8,
      tracking: {
        event: (route) => `fincraft_${route}_goto_backtesting`,
        step: 'goto_backtesting'
      }
    },
    {
      id: '7',
      helpCenterId: 'sectorAnalyzer1',
      name: 'Sektor-Analyzer',
      teaserText: 'Schau dir die Kennzahlen von Branchen an und suche Top-Down nach deinen Favoriten',
      type: 'Aktie',
      filterType: ['share'],
      to: {name: 'sektorAnalyzer'},
      hide: true,
      orderNumber: 9
    },
    {
      id: '8',
      helpCenterId: 'sharesComparison',
      name: 'Vergleiche Aktien',
      teaserText: 'Vergleiche die Aktien die dich interessieren um sicherzustellen, dass du die richtige Entscheidung triffst',
      type: 'Aktie',
      filterType: ['share'],
      to: {name: 'vergleicheAktien'},
      hide: true,
      orderNumber: 10
    },
    {
      id: '9',
      helpCenterId: 'etfsComparison',
      name: 'Vergleiche ETFs',
      teaserText: 'Vergleiche die ETFs die dich interessieren um sicherzustellen, dass du die richtige\n' +
        'Entscheidung triffst',
      type: 'ETF',
      filterType: ['etf'],
      to: {name: 'vergleicheEtfs'},
      hide: true,
      orderNumber: 11
    },
    {
      id: '12',
      helpCenterId: 'dividendenServiceAsTool',
      name: 'Dividendenservice',
      teaserText: 'Der Dividendenservice bucht die Dividenden und Ausschüttungen all deiner Wertpapiere in deinen Portfolios.',
      type: 'Portfolio',
      priceModelFeatureId: PRICEMODEL_FEATURE_IDS.AUTO_DIVIDEND_SERVICE.id,
      filterType: ['portfolio'],
      hideIfFeatureEnabled: true,
      to: undefined,
      hide: false,
      orderNumber: 12,
      tracking: {
        event: (route) => `fincraft_${route}_goto_dividendenService`,
        step: 'goto_dividendenService'
      }
    }
  ]
}
